/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundVariantDto } from '../../models/backend-own-fund-variant-dto';
import { BackendPatchedOwnFundVariantRequestDto } from '../../models/backend-patched-own-fund-variant-request-dto';

export interface FinancingSourcesOwnFundsVariantsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this own fund variant.
   */
  id: number;
  body?: BackendPatchedOwnFundVariantRequestDto;
}

export function financingSourcesOwnFundsVariantsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsVariantsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsVariantsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundVariantDto>;
    }),
  );
}

financingSourcesOwnFundsVariantsPartialUpdate$FormData.PATH = '/api/financing_sources/own_funds_variants/{id}/';
